import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBitcoin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBitcoin"><Path d="M9.5 7.5V12M9.5 7.5H8M9.5 7.5H13.25C14.4926 7.5 15.5 8.50736 15.5 9.75C15.5 10.9926 14.4926 12 13.25 12M9.5 12V16.5M9.5 12H13.25M9.5 16.5H8M9.5 16.5H13.25C14.4926 16.5 15.5 15.4926 15.5 14.25C15.5 13.0074 14.4926 12 13.25 12M12 6V7.5M12 16.5V18M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBitcoin;
